<template>
    <div class="row">
       <TodoBoard></TodoBoard>

        <ApplicantsBoard></ApplicantsBoard>

        <ShiftsBoard></ShiftsBoard>

       <StandByListBoard></StandByListBoard>
    </div>
</template>

<script >
import TodoBoard from "./TodoBoard.vue";
import ApplicantsBoard from "./ApplicantsBoard.vue";
import ShiftsBoard from "./ShiftsBoard.vue";
import StandByListBoard from "./StandByListBoard.vue";

export default {
    name: 'ListOfBoards',
    components: {StandByListBoard, ShiftsBoard, ApplicantsBoard, TodoBoard},
    data() {
        return {

        }
    }
}

</script>

<style scoped>

</style>
